import { render } from "./PrinterButton.vue?vue&type=template&id=8bf414e2&scoped=true"
import script from "./PrinterButton.vue?vue&type=script&lang=js"
export * from "./PrinterButton.vue?vue&type=script&lang=js"

import "./PrinterButton.vue?vue&type=style&index=0&id=8bf414e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bf414e2"]])

export default __exports__